import cx from 'classnames'

import {
  type PropsWithSafeExtra,
  safeRestProps,
} from '../../libs/safeRestProps'

type Props = PropsWithSafeExtra<'div', 'className' | 'children'>

/** Component used to display buttons in a flex row with gaps between each button.*/
export const ButtonContainer = ({
  className,
  children,
  extraProps = {},
  ...restProps // Needed since we can pass other props like aria-*, data-* etc. or spread that isn't type checked
}: Props) => (
  <div
    {...safeRestProps(extraProps, restProps)}
    className={cx('flex flex-row flex-wrap gap-1.5 items-center', className)}
  >
    {children}
  </div>
)
